"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateArrayImmutably = exports.removeFromObject = exports.isValidTime = exports.isValidMail = exports.isValidDate = exports.getTime = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var updateArrayImmutably = function updateArrayImmutably(arr, i, value) {
  return Object.assign(_toConsumableArray(arr), _defineProperty({}, i, value));
};

exports.updateArrayImmutably = updateArrayImmutably;

var removeFromObject = function removeFromObject(obj, key) {
  var removed = obj[key],
      objWithout = _objectWithoutProperties(obj, [key].map(_toPropertyKey));

  return objWithout;
};

exports.removeFromObject = removeFromObject;

var isValidDate = function isValidDate(date) {
  if (date) {
    if (date instanceof Date) {
      return true;
    } else if (!isNaN(new Date(date))) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};

exports.isValidDate = isValidDate;
var mailRegEx = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/);

var isValidMail = function isValidMail(mail) {
  return mailRegEx.test(mail);
};

exports.isValidMail = isValidMail;
var timeRegEx = RegExp(/(?:([0-9]?[0-9]):)?([0-9]?[0-9]):([0-9][0-9])/);

var isValidTime = function isValidTime(val) {
  return timeRegEx.test(val);
};

exports.isValidTime = isValidTime;

var getTime = function getTime(timeString) {
  if (timeString == null) return undefined;
  if (!isValidTime(timeString)) return parseInt(timeString, 10);
  var regExTimeArr = timeRegEx.exec(timeString); // ["01:12:33", "01", "12", "33", index: 0, input: "01:12:33", groups: undefined]

  return (regExTimeArr[1] || 0) * 3600 + regExTimeArr[2] * 60 + regExTimeArr[3] * 1;
};

exports.getTime = getTime;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/util/helpers.js
// module id = 176
// module chunks = 0